import { Accordion, Modal } from 'react-bootstrap'
import { TableReportSchedules } from './TableReportSchedules'
import Skeleton from 'react-loading-skeleton'
import { useEffect, useState } from 'react'
import { APISERVICE } from '../../services/api.service'

export function ModalSubjects({ show, onHide, teacherId, header }) {
    const [subjects, setSubjects] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (show) {
            if (teacherId) {
                loadSubjects(teacherId)
            } else {
                setSubjects([])
            }
        }
    }, [show])

    const loadSubjects = async (id) => {
        try {
            setLoading(true)
            const url = 'docente/schedules-enabled-by-teacher/?'
            const { data } = await APISERVICE.get(url, `idTeacher=${id}`)
            groupSubjects(data)
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const groupSubjects = (subjects) => {
        const groupSubjects = subjects.reduce((acc, subject) => {
            if (!acc[subject.materia_id]) {
                acc[subject.materia_id] = []
            }
            acc[subject.materia_id].push(subject)
            return acc
        }, {})
        setSubjects(Object.values(groupSubjects))
    }

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <span className='h5 mb-0'>{loading ? <Skeleton height={40} /> : header}</span>
            </Modal.Header>
            <Modal.Body>
                <Accordion defaultActiveKey={0}>
                    {subjects?.length > 0 ? (
                        subjects.map((subject, index) => (
                            <Accordion.Item eventKey={index} key={index}>
                                <Accordion.Header>
                                    {subject[0].nombre + ' - Grupo ' + subject[0].grupo}
                                </Accordion.Header>
                                <Accordion.Body>
                                    {subject?.length > 0 ? (
                                        <TableReportSchedules report={subject} />
                                    ) : (
                                        'No existen control permanencias completos'
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                        ))
                    ) : loading ? (
                        <Skeleton height={40} count={4} />
                    ) : (
                        <p>No existen materias habilitadas</p>
                    )}
                </Accordion>
            </Modal.Body>
        </Modal>
    )
}
